export default __webpack_public_path__ + "static/media/AppleLogo.95ec29ca.svg";